import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import * as userService from '../admin/services/userService'

import Swal from "sweetalert2";
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';

//import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { passRegex } from '../utils/Validations';

export function ForgPass() {


    const { onLogin } = useContext(AuthContext);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        egnParent: '',
        egnChild: '',
        parentPhone: '',
        email: '',
        newPass: '',
        confNewPass: '',
        captcha: '',

    });

    document.title = `Забравена парола`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const onSubmit = (e) => {
        e.preventDefault();

        //if (!passRegex.test(formData.newPass)) {
        //    Swal.fire({
        //        title: "Паролата трябва да съдържа поне 8 символа, включващи главни и малки букви, цифри и специален символ!",
        //        icon: "warning",
        //    });
        //    return;
        //}

        //if (validateCaptcha(formData.captcha, false) !== true) {
        //    Swal.fire({
        //        title: "Грешно попълнени символи от картинката!",
        //        icon: "warning",
        //    });
        //    return;
        //}

        //if (formData.newPass !== formData.confNewPass) {
        //    Swal.fire({
        //        title: "Възникна грешка",
        //        text: 'Паролите не съвпадат',
        //        icon: "warning",
        //    });

        //    return;
        //}

        userService.fpass(formData)
            .then(data => {
                onLogin(data);

                Swal.fire({
                    title: "Паролата е сменена успешно!",
                    text: 'Паролата е изпратена на посоченият от Вас email адрес. Ако не сте го получили, първо проверете в папката Spam(Trash)',
                    icon: "success",
                });

                navigate('/parent/');
            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                });
            });
    }

    //useEffect(() => {
    //    loadCaptchaEnginge(6);
    //}, []);

    return (
        <div>
            <div>
                <div className="title_entr">Забравена парола</div>

                {/*<p>За да може да промените вашата забравена парола е необходимо да въведете следните данни , които сте попълнили при вече направената регистрация.</p>*/}

                <div className="fp_form">

                    <form className="form" id="login" method="post" action="login">



                        <div className="form-group">
                            <div className="input-row">
                                <div className="input-group">
                                    <span className="p-float-label labels">
                                        <InputText name="egnParent" id="egnParent" style={{ width: '92.5%' }} value={formData.egnParent} onChange={handleChange} />
                                        <label htmlFor="egnParent">ЕГН на родител*</label>
                                    </span>
                                </div>

                                {/*<div className="input-group">*/}
                                {/*    <span className="p-float-label labels">*/}
                                {/*        <InputText name="egnChild" id="egnChild" style={{ width: '92.5%' }} value={formData.egnChild} onChange={handleChange} />*/}
                                {/*        <label htmlFor="egnChild">ЕГН Дете *</label>*/}
                                {/*    </span>*/}
                                {/*</div>*/}
                            </div>
                        </div>



                        {/*<div className="form-group mt-4">*/}
                        {/*    <div className="input-row">*/}
                        {/*        <div className="input-group">*/}
                        {/*            <span className="p-float-label labels">*/}
                        {/*                <InputText name='parentPhone' id="parentPhone" style={{ width: '92.5%' }} value={formData.parentPhone} onChange={handleChange} />*/}
                        {/*                <label htmlFor="pass">Телефон *</label>*/}
                        {/*            </span>*/}
                        {/*        </div>*/}

                        {/*        <div className="input-group">*/}
                        {/*            <span className="p-float-label labels">*/}
                        {/*                <InputText name='email' id="email" style={{ width: '92.5%' }} value={formData.email} onChange={handleChange} />*/}
                        {/*                <label htmlFor="email">Ел.поща *</label>*/}
                        {/*            </span>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {/*<div className="form-group mt-4">*/}
                        {/*    <div className="input-row">*/}
                        {/*        <div className="input-group">*/}
                        {/*            <span className="p-float-label labels">*/}
                        {/*                <Password*/}
                        {/*                    name='newPass'*/}
                        {/*                    value={formData.newPass}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                    style={{ width: '92.5%' }}*/}
                        {/*                    feedback={false}*/}
                        {/*                    toggleMask*/}
                        {/*                    className={`${formData.newPass.length > 5 || formData.newPass === '' ? '' : 'p-invalid'}`}*/}
                        {/*                />*/}
                        {/*                <label htmlFor="newPass">Нова парола *</label>*/}
                        {/*            </span>*/}
                        {/*        </div>*/}

                        {/*        <div className="input-group">*/}
                        {/*            <span className="p-float-label labels">*/}
                        {/*                <Password*/}
                        {/*                    name='confNewPass'*/}
                        {/*                    value={formData.confNewPass}*/}
                        {/*                    onChange={handleChange}*/}
                        {/*                    feedback={false}*/}
                        {/*                    toggleMask*/}
                        {/*                    style={{ width: '92.5%' }}*/}
                        {/*                    className={formData.confNewPass.length > 5 || formData.confNewPass === '' ? '' : 'p-invalid'}*/}
                        {/*                />*/}
                        {/*                <label htmlFor="confNewPass">Потвърждаване на парола *</label>*/}
                        {/*            </span>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}


                        {/*</div>*/}

                        {/*<div className="form-group">*/}
                        {/*    <div className="input-row">*/}
                        {/*        <div className="input-group pt-5">*/}
                        {/*            <div className="w-100">*/}
                        {/*                <LoadCanvasTemplate reloadText="Презареди символи" reloadColor="black" />*/}
                        {/*            </div>*/}

                        {/*            <InputText name='captcha' id="captcha" placeholder="въведете символите" style={{ width: '21.5%' }} value={formData.captcha} onChange={handleChange} />*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}





                        <div className="form-group">

                            <div className="input-group mt-5">
                                <button type="submit" id="" className="btn btn-info btn-cust" onClick={onSubmit}>Потвърди</button>
                            </div>

                        </div>




                    </form>

                </div>

            </div>
        </div>
    );
}

export default ForgPass;